import React, {useCallback, useEffect, useState} from 'react';
import './AIDocumentsList.scss';
import i18next from "i18next";
import DynamicList from "../../Lists/DynamicList/DynamicList";
import AIDocumentModal from "../../Modals/AIDocumentModal/AIDocumentModal";
import ConfirmationModal from "../../Modals/ConfirmationModal/ConfirmationModal";
import {momentFromDateTime} from "../../Helpers/DateHelpers";

const AIDocumentsList = ({ai, client, company, removeAIDocument, addAIDocument, didUpdateAI}) => {
  
  // Instance Variables
  
  const [companyDocument, setCompanyDocument] = useState(undefined);
  const [fixedObjectsArray, setFixedObjectsArray] = useState([]);
  const [aiDocumentToRemove, setAiDocumentToRemove] = useState(null);
  const [openAIDocumentModal, setOpenAIDocumentModal] = useState(false);
  
  const [columnsArray] = useState([
    {key:'name', columnWeight:3, columnNameKey:'NAME', propertiesArray:['name']},
    {key:'updated_at', columnWeight:1, columnNameKey:'SURVEY_DATE', propertiesArray:['updated_at'], valueFormatter:(aDate) => momentFromDateTime(aDate)},
    {key:'embedding_generated', columnWeight:1, columnNameKey:'PROCESSED', propertiesArray:['embedding_generated']}
  ]);
  
  const [menuItemsArray] = useState([
    {title:'DOWNLOAD', clickAction:(aAIDocument) => {
      const link = document.createElement('a');
      link.href = aAIDocument.file_url;
      link.download = aAIDocument.name;
      link.target = "_blank";
      link.style = "display:none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }},
    {title:'REMOVE', clickAction:(aAIDocument) => setAiDocumentToRemove(aAIDocument), isValid:(aAI) => aAI && aAI.id !== 'general'}
  ]);
  
  // Effects
  
  useEffect(() => {
    if(company && company.ai_information_file_url && company.ai_information_file_url.length > 0){
      if(ai && ai.id && ai.id.length > 0){
        setCompanyDocument({id:'general', name:'General', file_url:company.ai_information_file_url, updated_at:ai.updated_at, embedding_generated:true});
      }
      else{
        setCompanyDocument({id:'general', name:'General', file_url:company.ai_information_file_url, embedding_generated:true});
      }
    }
    else{
      setCompanyDocument(undefined);
    }
  }, [ai, company]);
  
  useEffect(() => {
    if(ai && ai.id && ai.id.length > 0){
      if(companyDocument){
        setFixedObjectsArray([companyDocument].concat(ai.documents));
      }
      else{
        setFixedObjectsArray(ai.documents);
      }
    }
    else{
      setFixedObjectsArray([]);
    }
  }, [ai, companyDocument]);
  
  // Methods
  
  const saveAIDocument = useCallback((aFile, aName) => {
    addAIDocument(undefined, ai && ai.id && ai.id.length > 0 ? ai.id : undefined, aName, aFile, client).then((newResult) => {
      if(Array.isArray(ai.documents)){
        ai.documents.push(newResult.data.saveAiDocumentMutation.ai_document);
      }
      else{
        ai.documents = [newResult.data.saveAiDocumentMutation.ai_document];
      }
      didUpdateAI(ai);
      setOpenAIDocumentModal(false);
    }, (newError) => {
    
    });
  }, [ai, client, didUpdateAI, addAIDocument]);
  
  const deleteAIDocument = useCallback(() => {
    removeAIDocument(aiDocumentToRemove && aiDocumentToRemove.id && aiDocumentToRemove.id.length > 0 ? aiDocumentToRemove.id : undefined).then((newResult) => {
      if(Array.isArray(ai.documents)){
        for(let index = 0; index < ai.documents.length; index += 1){
          let document = ai.documents[index];
          
          if(document.id === newResult.data.data.removeAiDocumentMutation.ai_document.id){
            ai.documents.splice(index, 1);
            break;
          }
        }
        setAiDocumentToRemove(null);
        didUpdateAI(ai);
      }
    }, (newError) => {
    
    });
  }, [ai, didUpdateAI, removeAIDocument, aiDocumentToRemove]);
  
  // Render
  
  return (
    ai && ai.id && ai.id.length > 0 ?
      <>
        <DynamicList id="ai-documents-list"
                     columnsArray={columnsArray}
                     menuItemsArray={menuItemsArray}
                     minColumnWidth={100}
                     addButtonClicked={() => setOpenAIDocumentModal(true)}
                     fixedObjectsArray={fixedObjectsArray}
        />
        
        <AIDocumentModal open={openAIDocumentModal}
                         save={saveAIDocument}
                         close={() => setOpenAIDocumentModal(false)}
        />
        
        <ConfirmationModal title={i18next.t('REMOVE_AI_DOCUMENT', {aName:aiDocumentToRemove ? aiDocumentToRemove.name : ''})}
                           isOpen={aiDocumentToRemove !== null}
                           reject={() => setAiDocumentToRemove(null)}
                           confirm={deleteAIDocument}
        />
      </>
      :
      null
  );
};

export default AIDocumentsList
